// extracted by mini-css-extract-plugin
export var actionButton = "_82-1";
export var actionButtons = "_82-2";
export var actions = "_82-0";
export var aiUnread = "_82-10";
export var alignCenter = "_82-h";
export var backWrapper = "_82-3";
export var cellContainer = "_82-4";
export var checkboxContainer = "_82-5";
export var contentContainer = "_82-6";
export var contentHeader = "_82-8";
export var conversationsTableWrapper = "_82-s";
export var draftReplyBadgeContainer = "_82-m";
export var dropdownItem = "_82-b";
export var dropdownItemsContainer = "_82-a";
export var dropdownTitle = "_82-c";
export var errorIcon = "_82-7";
export var filter = "_82-d";
export var gray = "_82-i";
export var headerActionButtons = "_82-e";
export var headerCheckboxContainer = "_82-f";
export var icon = "_82-j";
export var menuContainer = "_82-k";
export var noMoreTicketsIcon = "_82-12";
export var noMoreTicketsSubText = "_82-13";
export var oneLine = "_82-l";
export var optionsButton = "_82-n";
export var plus = "_82-o";
export var portalButtonsWrapper = "_82-g";
export var red = "_82-p";
export var scrolledTop = "_82-9";
export var search = "_82-q";
export var selectedConversationsCount = "_82-r";
export var spinner = "_82-t";
export var strong = "_82-u";
export var summaryCell = "_82-v";
export var tableContainer = "_82-11";
export var tagContainer = "_82-w";
export var threeDots = "_82-x";
export var twoLines = "_82-y";
export var unread = "_82-z";